import React, { useRef, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import { NextIcon } from "../../Icons"
import "./TickerInput.css"

function ErrorBox({ message, hideErrorBox }) {
  const box = useRef(null)
  const handleClickOutside = useCallback(
    () => {
      hideErrorBox && hideErrorBox()
    },
    [hideErrorBox]
  )
  useEffect(
    () => {
      document.addEventListener("mousedown", handleClickOutside)

      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    },
    [handleClickOutside]
  )

  return (
    <div ref={box} className="ErrorBox">
      <span>{message}</span>
    </div>
  )
}

class TickerInput extends React.Component {
  state = {
    maxError: "",
    minError: ""
  }
  handleChange = e => {
    const val = e.target.value
    this.props.handleChange && this.props.handleChange(val)
  }

  hideErrorBox = () => {
    this.setState({
      maxError: "",
      minError: ""
    })
  }

  handleBlur = e => {
    let val = 0
    const inputValue = Number(e.target.value)
    const max = this.props.max
    const min = this.props.min

    if (!isNaN(inputValue) && inputValue !== "") {
      if (inputValue <= max && inputValue >= min) {
        this.setState({ maxError: "" })
        val = inputValue
      } else {
        if (this.props.showMaxError && inputValue > max) {
          this.setState({
            maxError:
              this.props.maxError ||
              "You have reached the maximum quantity available.",
            minError: ""
          })
          val = max
        }
        if (this.props.showMinError && inputValue < min) {
          this.setState({
            maxError: "",
            minError:
              this.props.minError ||
              "You have reached the minimum quantity available."
          })
          val = min
        }
      }
    } else {
      val = min || 0
    }
    this.props.setValue && this.props.setValue(val)
  }

  tickUp = () => {
    this.setState({ minError: "" })
    const max = this.props.max || 999999999
    const val =
      parseInt(this.props.value) + 1 > max
        ? max
        : parseInt(this.props.value) + 1
    this.props.setValue && this.props.setValue(val)
    if (this.props.showMaxError && parseInt(this.props.value) + 1 > max) {
      this.setState({
        maxError:
          this.props.maxError ||
          "You have reached the maximum quantity available."
      })
    } else {
      this.setState({ maxError: "" })
    }
  }

  tickDown = () => {
    this.setState({ maxError: "" })
    const val =
      (this.props.min &&
        this.props.value - 1 < this.props.min &&
        this.props.min) ||
      this.props.value - 1
    this.props.setValue && this.props.setValue(val)
    if (
      this.props.showMinError &&
      parseInt(this.props.value) - 1 < this.props.min
    ) {
      this.setState({
        minError:
          this.props.minError ||
          "You have reached the minimum quantity available."
      })
    } else {
      this.setState({ minError: "" })
    }
  }

  render() {
    return (
      <div className="TickerInput">
        <button
          type="button"
          onClick={this.tickDown}
          className={
            this.props.value <= this.props.min || this.props.disabled
              ? "inactive"
              : "active"
          }
          disabled={this.props.disabled}
        >
          <NextIcon />
        </button>
        <input
          type="text"
          value={this.props.value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          disabled={this.props.disabled}
        />
        <button
          type="button"
          onClick={this.tickUp}
          className={
            this.props.value >= this.props.max || this.props.disabled
              ? "inactive"
              : "active"
          }
          disabled={this.props.disabled}
        >
          <NextIcon />
        </button>
        {(this.state.maxError &&
          this.state.maxError !== "" &&
          this.props.showMaxError && (
            <ErrorBox
              hideErrorBox={this.hideErrorBox}
              message={this.state.maxError}
            />
          )) ||
          null}
        {(this.state.minError &&
          this.state.minError !== "" &&
          this.props.showMinError && (
            <ErrorBox
              hideErrorBox={this.hideErrorBox}
              message={this.state.minError}
            />
          )) ||
          null}
      </div>
    )
  }
}

TickerInput.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.number,
  min: PropTypes.number,
  showMaxError: PropTypes.bool,
  showMinError: PropTypes.bool
}

TickerInput.defaultProps = {
  handleChange: () => {},
  value: 0,
  max: 999999999,
  min: -999999999,
  showMaxError: false,
  showMinError: false
}

export default TickerInput
